import React from 'react';
import { Phone, Mail, MapPin, MessageCircle, Navigation } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white mt-20">
      {/* Sticky Action Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-2xl border-t border-gray-200 z-40 md:hidden">
        <div className="flex justify-around items-center py-3 px-4">
          <a
            href="tel:+919876543210"
            data-testid="sticky-call-button"
            className="flex flex-col items-center gap-1"
          >
            <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
              <Phone className="w-5 h-5 text-white" />
            </div>
            <span className="text-xs text-gray-700 font-medium">Call</span>
          </a>
          <a
            href="https://wa.me/919876543210"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-whatsapp-button"
            className="flex flex-col items-center gap-1"
          >
            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <span className="text-xs text-gray-700 font-medium">WhatsApp</span>
          </a>
          <a
            href="https://maps.google.com/?q=Kolar+Gold+Fields+Karnataka+India"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-directions-button"
            className="flex flex-col items-center gap-1"
          >
            <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
              <Navigation className="w-5 h-5 text-white" />
            </div>
            <span className="text-xs text-gray-700 font-medium">Directions</span>
          </a>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Dr. B. Rajendra Kumar</h3>
            <p className="text-gray-300 text-sm mb-4">
              Providing free, technology-driven healthcare to KGF mine workers and their families for over 25 years.
            </p>
            <div className="space-y-2">
              <p className="text-gray-300 text-sm flex items-center gap-2">
                <Phone className="w-4 h-4" />
                +91 9876543210
              </p>
              <p className="text-gray-300 text-sm flex items-center gap-2">
                <Mail className="w-4 h-4" />
                info@drbrajendrakumar.com
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/about" className="text-gray-300 hover:text-white text-sm">About Doctor</a></li>
              <li><a href="/services" className="text-gray-300 hover:text-white text-sm">Our Services</a></li>
              <li><a href="/appointments" className="text-gray-300 hover:text-white text-sm">Book Appointment</a></li>
              <li><a href="/gallery" className="text-gray-300 hover:text-white text-sm">Gallery</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-white text-sm">Contact Us</a></li>
            </ul>
          </div>

          {/* Clinic Hours */}
          <div>
            <h3 className="text-xl font-bold mb-4">Clinic Hours</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p><strong className="text-white">OPD:</strong> 5:00 AM - 11:00 AM</p>
              <p><strong className="text-white">Days:</strong> Monday - Saturday</p>
              <p><strong className="text-white">Closed:</strong> Sunday</p>
            </div>
            <div className="mt-4">
              <a
                href="https://wa.me/919876543210"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-button"
              >
                <Button className="w-full bg-green-500 hover:bg-green-600 flex items-center justify-center gap-2">
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp Us
                </Button>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Dr. B. Rajendra Kumar Clinic. All Rights Reserved.
            </p>
            <p className="text-gray-400 text-sm text-center md:text-right">
              Powered By <span className="text-cyan-400 font-semibold">Threem Technology Solutions Pvt Ltd</span>
            </p>
          </div>
        </div>
      </div>

      {/* Spacer for sticky mobile footer */}
      <div className="h-20 md:h-0"></div>
    </footer>
  );
};

export default Footer;
